/**
 * コレクションのページネーション後、先頭の一瞬表示→ハッシュジャンプの「ガクッ」と感じる挙動を抑える。
 * - URL には # を付けない（ブラウザのハッシュスクロールと競合させない）
 * - ページネーションのリンクをクリックしたときだけ sessionStorage にフラグ
 * - 読み込み直後に scrollIntoView（スムーズ／アクセシビリティは instant）
 * - PC: 並び替え行（#c-main-collection-scroll-target）を優先し絞り込み・並び替えが見える位置へ
 * - SP: 従来どおり #c-main-collection
 */
(function () {
  var KEY = "c-main-collection-scroll-pending";

  function getScrollTarget() {
    var desktop = window.matchMedia("(min-width: 750px)").matches;
    if (!desktop) {
      return document.getElementById("c-main-collection");
    }
    var sortRow = document.getElementById("c-main-collection-scroll-target");
    if (sortRow) return sortRow;
    var filters = document.getElementById("main-collection-filters");
    if (filters) return filters;
    return document.getElementById("c-main-collection");
  }

  document.addEventListener(
    "click",
    function (e) {
      var a = e.target.closest(".c_main-collection .c_pagination a[href]");
      if (!a) return;
      try {
        sessionStorage.setItem(KEY, "1");
      } catch (err) {}
    },
    true,
  );

  function runScroll() {
    var el = getScrollTarget();
    if (!el) return;

    var shouldScroll = false;
    try {
      if (sessionStorage.getItem(KEY) === "1") {
        sessionStorage.removeItem(KEY);
        shouldScroll = true;
      }
    } catch (err) {}

    if (!shouldScroll && location.hash === "#c-main-collection") {
      shouldScroll = true;
      try {
        if (history.replaceState) {
          var u = new URL(location.href);
          u.hash = "";
          history.replaceState(null, "", u.pathname + u.search);
        }
      } catch (err) {}
    }

    if (!shouldScroll) return;

    scrollCollectionIntoView(el);
  }

  /**
   * PC: ヘッダー実測高さ（スティッキー包含ブロック優先）で位置決め。CSS の scroll-margin より確実にナビ下に余白を取る。
   * SP: scrollIntoView（従来どおり）
   */
  function scrollCollectionIntoView(el) {
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)")
      .matches;
    var behavior = reduced ? "instant" : "smooth";
    var desktop = window.matchMedia("(min-width: 750px)").matches;

    if (!desktop) {
      el.scrollIntoView({ block: "start", behavior: behavior });
      return;
    }

    var header = document.querySelector("c-store-header");
    if (!header) {
      el.scrollIntoView({ block: "start", behavior: behavior });
      return;
    }

    function doScroll() {
      var stickyWrap = header.closest('[id^="shopify-section"]');
      var headerBox = (stickyWrap || header).getBoundingClientRect();
      var gap = 12;
      var rect = el.getBoundingClientRect();
      var targetY = rect.top + window.pageYOffset - headerBox.height - gap;
      window.scrollTo({
        top: Math.max(0, targetY),
        behavior: behavior,
      });
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(doScroll);
    });
  }

  /* defer かつセクション末尾なので、この時点で #c-main-collection は存在する */
  runScroll();
})();

